import { useMutation } from "react-query";
import { selectDecision } from "@/services/tasks";
/** Mutation hook to select or clear the active decision for a suggestion. */
export function useSelectDecision(patientUid, reminderId) {
  return useMutation(function (payload) {
    return selectDecision(patientUid, reminderId, payload);
  }, {
    onError: function onError() {}
  });
}